import * as React from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { ICorporateRegion } from '../../model/ICorporateRegion';
import { FlightReport, getErrorMessages, IFlightReport, setFlightReportErrors } from '../../model/IFlightReport';
import { IPaginationResult } from '../../model/search/IPaginationResult';
import { CorporateRegionDomainService, getCorporateRegion } from '../../services/domainServices/CorporateRegionDomainService';
import { FlightReportService } from '../../services/flightReport/FlightReportService';
import { getContractRegistration } from '../../services/HiringContractService';
import { hiringContractsState, activeContractsState } from '../../state/DomainService.state';
import { FlightReportCRUD } from '../../operations/FlightReportCRUD';
import FlightReportStatus from '../../model/enum/FlightReportStatus';
import { convertFireNumbersToArrayOptions } from '../../services/domainServices/FireNumberService';
import { convertCrewTypesToArrayOptions } from '../../services/domainServices/CrewTypeService';
import { convertCostingActivitiesToArrayOptions } from '../../services/domainServices/CostingActivityService';
import { bindRateTypeDropdown, convertRateTypesToArrayOptions } from '../../services/domainServices/RateTypeService';
import { bindRateUnitDropdown, convertRateUnitsToArrayOptions } from '../../services/domainServices/RateUnitService';
import { useAuth } from 'react-oidc-context';
import { bindInternalOrderDropdown, convertInternalOrdersToArrayOptions } from '../../services/1GXCoding/InternalOrderService';
import { bindCostCenterDropdown, convertCostCentersToArrayOptions } from '../../services/1GXCoding/CostCenterService';
import { convertFundsToArrayOptions } from '../../services/1GXCoding/FundService';
import { convertAccountsToArrayOptions } from '../../services/1GXCoding/AccountService';
import { IArrayOption } from '../../model/IArrayOption';
import { ISearch } from '../../model/search/ISearch';
import { IFilter } from '../../model/search/IFilter';
import { IPagination } from '../../model/search/IPagination';
import { Suspense, useEffect, useState } from 'react';
import { GoAButton, GoAButtonGroup, GoACircularProgress, GoAModal } from '@abgov/react-components';

import styles from './FlightReportDetail.module.scss';
import SideBar from './layout/sideBar/SideBar';
import MainPanel from './layout/mainPanel/MainPanel';
import { validationEnginService } from '../../services/ValidationEnginService';
import { getFlyingHoursDomainData, IDomainData, IDomainDataOptions } from './helpers/DomainDataHelper';
import { getFlyingHours } from './helpers/FlyingHoursHelper';
import { getFlyingHoursErrorMessages, IFlyingHours } from '../../model/IFlyingHours';
import { FlyingHoursService } from '../../services/flyingHours/FlyingHoursService';
import axios from 'axios';
import { IValidationError } from '../../model/errors/IValidationError';
import moment from 'moment';
import ContractType from '../../model/enum/ContractType';
import { ExpenseDetailCRUD } from '../../operations/ExpenseDetailCRUD';
import { onFlightReportSaveCreateBasingExpenseLongTerm } from './helpers/FlightReportHelper';
import CalloutVariant from '../../model/enum/CalloutVariant';
import { ExpenseService } from '../../services/expense/ExpensesService';
import { FlightExpenses, getExpenseDetailErrorMessages, getFlightOtherExpensesErrorMessages } from '../../model/IFlightExpense';
import { FlyingDetailCRUD } from '../../operations/FlyingDetailCRUD';
import { FlightReportNote } from '../../model/IFlightReportNote';
import { notesService } from '../../services/notes/NotesService';
import { removeStringCharacters } from '../../utils/commonMethods';
import { UnserviceableLogService } from '../../services/Unserviceable/UnserviceableLogService';
import { getUSLogErrorMessages, IUSLog } from '../../model/Unserviceable/IUSLog';
import { IUSStandToStandDown, USStandToStandDown } from '../../model/Unserviceable/IUSStandToStandDown';
import { StandToStandDownTimeService } from '../../services/Unserviceable/StandToStandDownTimeService';
import { setUsStandToStandDownErrors } from '../Unserviceable/EditStandToStandDownTime';
const { container } = styles;
interface IFlightReportDetailProps {
  corporateRegions?: IPaginationResult<ICorporateRegion> | undefined;
}
// test comment
const FlightReportDetail: React.FunctionComponent<IFlightReportDetailProps> = ({ corporateRegions, ...props }) => {
  const auth = useAuth();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const [tempFlightReport, setTempFlightReport] = useState(new FlightReport());
  const [isLoaded, setIsLoaded] = useState(false);
  const [flightReport, setFlightReport] = useState<IFlightReport>(new FlightReport());
  const hiringContractsStateResult = useRecoilValue(hiringContractsState);

  const [isLoading, setIsLoading] = useState(false);

  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState<
    'flightreport' | 'flyinghours' | 'expenses' | 'standtostanddown' | 'logs' | 'notes' | 'none'
  >('none');

  const [corporateRegionPaginationResult, setCorporateRegionPaginationResult] = useState<IPaginationResult<ICorporateRegion>>(location.state);

  const [tempFlyingHours, setTempFlyingHours] = useState<IFlyingHours[]>([]);
  const [flyingHours, setFlyingHours] = useState<IFlyingHours[]>([]);

  const [expensesData, setExpensesData] = useState<FlightExpenses>(new FlightExpenses());
  const [tempExpensesData, setTempExpensesData] = useState<FlightExpenses>(new FlightExpenses());

  const [notes, setNotes] = useState<FlightReportNote[]>([]);

  const [usLogs, setUsLogs] = useState<IUSLog[]>([]);
  const [tempUsLogs, setTempUsLogs] = useState<IUSLog[]>([]);
  const [uSStandToStandDown, setUSStandToStandDown] = useState<USStandToStandDown>();
  const [tempUSStandToStandDown, setTempUSStandToStandDown] = useState<USStandToStandDown>();

  const [showNoFlyDayModal, setShowNoFlyDayModal] = useState(false);
  const [showUnserviceableReportModal, setShowUnserviceableReportModal] = useState(false);

  const [isDataValid, setIsDataValid] = useState(true);
  const setAircraftDetails = useSetRecoilState(hiringContractsState);
  const setAircraftActiveContracts = useSetRecoilState(activeContractsState);
  const [ruleCode, setRuleCode] = useState('');
  const feature = 'AviationReporting';
  const api = 'CreateFlightReport';
  const [warningMessage, setWarningMessage] = useState('');
  const [calloutVariant, setCalloutVariant] = useState(CalloutVariant.success);
  const [modalHeading] = React.useState('');
  const [notificationMessage, setNotificationMessage] = useState('');
  useEffect(() => {
    document.title = 'Flight Report | Aviation';
  }, []);

  const getNotes = async (flightReportId: number) => {
    try {
      let objIPagination: IPagination = {
        perPage: 100,
        page: 1,
      };

      let objIFilter: IFilter = {
        columnName: 'expenseType',
        columnValue: 'FlyingHours',
      };

      let objISearch: ISearch = {
        search: '',
        sortBy: '',
        sortOrder: '',
        filterBy: objIFilter,
        pagination: objIPagination,
      };
      const response = await notesService.getNotes(objISearch, flightReportId, auth.user?.access_token as string);
      setNotes(response.data.data);
    } catch (error) {
      console.error('Error fetching notes:', error);
    }
  };
  async function onNotesChange() {
    await getNotes(tempFlightReport.flightReportId);

    //Change status from submitted to inprogress
    if (tempFlightReport.status === FlightReportStatus.submitted) {
      onSubmittedStatusChange();
    }
  }
  useEffect(() => {
    setIsLoaded(false);
    if (id === 'new') {
      const fr = new FlightReport();
      setTempFlightReport(fr);
      setFlightReport(fr);
      const token = auth.user?.access_token;
      if (token) {
        const fetchData = async () => {
          // await getFlightReport(id);
          const corporateRegions = await getCorporateRegions();
          setCorporateRegionPaginationResult(corporateRegions);
          const data = await getFlyingHoursDomainData(token);
          setDomainData(data);
          setIsLoaded(true);
        };
        fetchData();
      }
    } else if (id) {
      const fetchData = async () => {
        const corporateRegions = await getCorporateRegions();
        setCorporateRegionPaginationResult(corporateRegions);
        await getFlightReport(id, corporateRegions);
        setIsLoaded(true);
      };
      fetchData();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, auth]);

  const { flightReportDate } = tempFlightReport ?? {};

  const [domainData, setDomainData] = useState<IDomainData>({
    fireNumbers: [],
    costingActivities: [],
    rateTypes: [],
    crewTypes: [],
    rateUnits: [],
    internalOrders: [],
    costCenters: [],
    funds: [],
    accounts: [],
  });

  useEffect(() => {
    const token = auth.user?.access_token;
    if (!token || !flightReportDate) return;
    const fetchData = async () => {
      const data = await getFlyingHoursDomainData(token, flightReportDate);
      setDomainData(data);
      setDomainDataOptions(data);
    };

    fetchData();
  }, [auth.user?.access_token, flightReportDate]);

  useEffect(() => {
    validationEnginService
      .getRules(feature, api, auth.user?.access_token as string)
      .then((response: any) => {
        if (response.data && response.status) setRuleCode(response.data.frontEndCode);
      })
      .catch((e: Error) => {
        console.log('Error', e);
      });
  }, [ruleCode, auth.user?.access_token]);

  async function onNoFlyDayConfirmChanges() {
    const newFlightReport = {
      ...tempFlightReport,
      meterStart: undefined,
      meterFinish: undefined,
      pointOfDeparture: '',
      noFlyDay: true,
    };
    setTempFlightReport(new FlightReport({ ...newFlightReport }));

    const updated = tempFlyingHours.map((x) => ({
      ...x,
      deleted: true,
    }));

    setTempFlyingHours(updated);

    setShowNoFlyDayModal(false);
  }

  function onUnserviceableReportCancel() {
    setTempFlightReport(
      new FlightReport({
        ...tempFlightReport,
        unserviceableReport: true,
      }),
    );
    setShowUnserviceableReportModal(false);
  }

  //on Yes, Confirm Unserviceable Report modal pop up
  async function onUnserviceableReportConfirm() {
    if (tempUSStandToStandDown) {
      setTempUSStandToStandDown({ ...tempUSStandToStandDown, deleted: true });
      const updated = tempUsLogs.map((x) => ({
        ...x,
        deleted: true,
      }));
      setTempUsLogs(updated);
    }
    setShowUnserviceableReportModal(false);
  }
  const getFlightReport = async (flightReportId: string, corporateRegions: IPaginationResult<ICorporateRegion>) => {
    setIsLoading(true);
    try {
      const response = await FlightReportService.getById(flightReportId, auth.user?.access_token as string);

      var vendorResult;
      //get aircraft registration
      var aircraftHiringContract = await FlightReportCRUD.getHiringContract(response.data.flightReportDate, auth.user?.access_token as string);

      if (aircraftHiringContract) setAircraftDetails(aircraftHiringContract);

      var aircraftActiveContract = await FlightReportCRUD.getActiveContract(response.data.flightReportDate, '', auth.user?.access_token as string);

      if (aircraftActiveContract) setAircraftActiveContracts(aircraftActiveContract);

      //Get contract registration
      if (response.data.contractRegistrationId)
        var contractRegistrationObj = getContractRegistration(aircraftHiringContract, response.data.contractRegistrationId);

      var CharterNoteListResult = await FlightReportCRUD.getCharterNotes(response.data.hiringDetailsId as number, auth.user?.access_token as string);

      //Get flying registration
      if (response.data.flyingRegistrationId)
        var flyingRegistrationObj = getContractRegistration(aircraftHiringContract, response.data.flyingRegistrationId);

      vendorResult = {
        name: contractRegistrationObj?.name1,
        financeVendorId: contractRegistrationObj?.financeVendorId,
      };

      //Get corporate region
      if (response.data.corporateRegionId) var corporateRegion = getCorporateRegion(corporateRegions, response.data.corporateRegionId);

      //set hiringStartDate, hiringEndDates, pointOfHire
      response.data.hiringStartDate = contractRegistrationObj?.effectiveDate;
      response.data.hiringEndDate = contractRegistrationObj?.terminationDate;
      response.data.pointOfHire = contractRegistrationObj?.pointOfHire;
      response.data.remark = contractRegistrationObj?.remark;

      //Set flight report with corporate region
      const fr = new FlightReport({
        ...response.data,
        corporateRegion: corporateRegion,
        vendor: vendorResult,
        contractRegistration: contractRegistrationObj,
        flyingRegistration: flyingRegistrationObj,
        charternotelist: CharterNoteListResult,
      });
      setTempFlightReport(fr);
      setFlightReport(fr);

      //Get domain service data for flying hours & expense
      const data = await getFlyingHoursDomainData(auth.user?.access_token as string, fr.flightReportDate);
      setDomainData(data);
      //  need to get the flying hours but set the options lower down
      const options = setDomainDataOptions(data);

      // move this to tab
      const flyingHoursData = await getFlyingHours(
        response.data.flightReportId,
        auth.user?.access_token as string,
        options.fireNumberOptions,
        options.crewTypeOptions,
        options.costingActivityOptions,
        options.rateTypeOptions,
        options.rateUnitOptions,
        options.internalOrderOptions,
        options.costCenterOptions,
        options.fundOptions,
        options.accountOptions,
      );
      setFlyingHours(flyingHoursData);
      setTempFlyingHours(flyingHoursData);

      await getExpenses(
        response.data.flightReportId,
        response.data.flightReportDate,
        options.fireNumberOptions,
        options.crewTypeOptions,
        options.costingActivityOptions,
        options.rateTypeOptions,
        options.rateUnitOptions,
        options.internalOrderOptions,
        options.costCenterOptions,
        options.fundOptions,
        options.accountOptions,
      );
      await getNotes(response.data.flightReportId);
      await getUnserviceableStandToStandDownTime(response.data.flightReportId, response.data.flightReportDate);
      if (response.data.unserviceableReport) await getUSLog(response.data.flightReportId);
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };
  const setDomainDataOptions = (data: IDomainData): IDomainDataOptions => {
    const fireNumberOptions = convertFireNumbersToArrayOptions(data.fireNumbers);
    setFireNumberOptions(fireNumberOptions);

    const crewTypeOptions = convertCrewTypesToArrayOptions(data.crewTypes);
    setCrewTypeOptions(crewTypeOptions);

    const costingActivityOptions = convertCostingActivitiesToArrayOptions(data.costingActivities);
    setCostingActivityOptions(costingActivityOptions);

    const rateTypeOptions = convertRateTypesToArrayOptions(data.rateTypes);
    setRateTypeOptions(rateTypeOptions);

    const rateUnitOptions = convertRateUnitsToArrayOptions(data.rateUnits);
    setRateUnitOptions(rateUnitOptions);

    const internalOrderOptions = convertInternalOrdersToArrayOptions(data.internalOrders);
    setInternalOrderOptions(internalOrderOptions);

    const costCenterOptions = convertCostCentersToArrayOptions(data.costCenters);
    setCostCenterOptions(costCenterOptions);

    const fundOptions = convertFundsToArrayOptions(data.funds);
    setFundOptions(fundOptions);
    const accountOptions = convertAccountsToArrayOptions(data.accounts);
    setAccountOptions(accountOptions);

    return {
      fireNumberOptions,
      crewTypeOptions,
      costingActivityOptions,
      rateTypeOptions,
      rateUnitOptions,
      internalOrderOptions,
      costCenterOptions,
      fundOptions,
      accountOptions,
    };
  };
  //Corporate region
  const getCorporateRegions = async (): Promise<IPaginationResult<ICorporateRegion>> => {
    let objIPagination: IPagination = {
      perPage: 20,
      page: 1,
    };

    let objIFilter: IFilter = {
      columnName: 'corporateRegionTypeId',
      columnValue: '4',
    };

    let objISearch: ISearch = {
      search: '',
      filterBy: objIFilter,
      pagination: objIPagination,
    };

    const response = await CorporateRegionDomainService.getSearch(objISearch, auth.user?.access_token as string);
    return response.data;
    // if (response.data) {
    //     setCorporateRegionPaginationResult(response.data);
    // }
  };

  async function getExpenses(
    flightReportId: number,
    flightReportDate: string,
    fireNumberOptions: IArrayOption[],
    crewTypeOptions: IArrayOption[],
    costingActivityOptions: IArrayOption[],
    rateTypeOptions: IArrayOption[],
    rateUnitOptions: IArrayOption[],
    internalOrderOptions: IArrayOption[],
    costCenterOptions: IArrayOption[],
    fundOptions: IArrayOption[],
    accountOptions: IArrayOption[],
  ) {
    try {
      const response = await ExpenseService.getById(flightReportId, auth.user?.access_token as string);

      if (response.data) {
        response.data.flightCrewEligibility.map(async (record: any) => {
          if (!record.createUserId) {
            record.createUserId = auth?.user?.profile?.name ?? 'wildfire';
          }
        });

        response.data?.expenseDetails?.forEach(async function (record: any, index: any) {
          //Drop down list bind
          record.fireNumberList = fireNumberOptions ?? undefined;
          record.crewTypeList = crewTypeOptions ?? undefined;
          record.costingActivityList = costingActivityOptions ?? undefined;
          record.rateTypeList = rateTypeOptions ?? undefined;
          record.rateUnitList = rateUnitOptions ?? undefined;

          //1GX coding - financial
          //Find the internal order if it is not in the list
          if (record.internalOrder === '' || internalOrderOptions.find((x) => x.value === record.internalOrder)) {
            record.internalOrderList = internalOrderOptions ?? undefined;
          } else {
            var internalOrderResponse: any = await FlyingDetailCRUD.getInternalOrder(record.internalOrder, auth.user?.access_token as string);
            if (internalOrderResponse.data) {
              const internalOrderResult = bindInternalOrderDropdown(internalOrderResponse.data);
              record.internalOrderList = internalOrderResult ?? undefined;
            }
          }

          //Find the cost center if it is not in the list
          if (record.costCenter === '' || costCenterOptions.find((x) => x.value === record.costCenter)) {
            record.costCenterList = costCenterOptions ?? undefined;
          } else {
            var costCenterResponse: any = await FlyingDetailCRUD.getCostCenter(record.costCenter, auth.user?.access_token as string);
            if (costCenterResponse.data) {
              const costCenterResult = bindCostCenterDropdown(costCenterResponse.data);
              record.costCenterList = costCenterResult ?? undefined;
            }
          }

          //1GX coding - financial
          record.fundList = fundOptions ?? undefined;
          record.accountList = accountOptions ?? undefined;
        });

        if (response.data?.flightOtherExpenses) {
          var flightOtherExpensesObj = response.data?.flightOtherExpenses;
          flightOtherExpensesObj.createTimestamp = moment(new Date()).format('yyyy-MM-DD');
          flightOtherExpensesObj.updateTimestamp = moment(new Date()).format('yyyy-MM-DD');
        }

        let flightExpensesDataSorted = ExpenseDetailCRUD.sortingExpenseData(response.data);

        const hiringContracts = await FlightReportCRUD.getHiringContract(flightReportDate, auth.user?.access_token as string);

        flightExpensesDataSorted.contractType = hiringContracts?.find((x) => x.id === tempFlightReport.contractRegistrationId)?.contractType ?? '';

        setExpensesData(flightExpensesDataSorted);
        setTempExpensesData(flightExpensesDataSorted);

        setIsLoading(false);
      }
    } catch (e) {
      setIsLoading(false);
      console.log('Error', e);
      throw e;
    }
  }

  const getUSLog = async (flightReportId: number) => {
    await UnserviceableLogService.getById(flightReportId.toString(), auth.user?.access_token as string)
      .then(async (response: any) => {
        if (response.status) {
          var strStartTimeSubstr = '',
            strEndTimeSubstr = '';
          //Bind data based on ID
          response.data.data?.forEach(async function (record: any, index: any) {
            //Set Unserviceable Start Time, End Time
            if (record.startTime) strStartTimeSubstr = removeStringCharacters(record.startTime, 3);

            if (record.endTime) strEndTimeSubstr = removeStringCharacters(record.endTime, 3);

            record.startTime = strStartTimeSubstr;
            record.endTime = strEndTimeSubstr;
          });

          setUsLogs([...response.data.data]);
          setTempUsLogs([...response.data.data]);
        }
      })
      .catch((e: Error) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  function onSubmittedStatusChange() {
    setTempFlightReport(
      new FlightReport({
        ...tempFlightReport,
        status: FlightReportStatus.inProgress,
      }),
    );
  }
  function setError(error: any) {
    var validationError = '';

    if (axios.isAxiosError(error)) {
      if (error.response) {
        var validation = error.response.data as IValidationError;
        if (validation) {
          validation.validationResult?.forEach((record: any, index: any) => {
            if (record && record.type !== 'Warning') validationError += '<p>' + record.message + '</p>';
          });
        }
        if (validation?.errorMessage) {
          validationError = validationError + '<p>' + validation.errorMessage + '</p>';
        }
      }
    } else {
      console.error('else', error);
    }

    if (validationError !== '') {
      setCalloutVariant(CalloutVariant.emergency);
      setNotificationMessage(validationError);
    }

    setWarning(error.response.data);
    setIsLoading(false);
  }

  async function setWarning(warning: any) {
    var validationWarning = '';
    var hasError = false;

    if (warning) {
      warning.validationResult?.forEach((record: any, index: any) => {
        if (record && record.type === 'Warning') validationWarning += record.message + '\r\n';

        if (record && record.type === 'Error') hasError = true;
      });

      if (!hasError && validationWarning !== '') {
        setWarningMessage(validationWarning);
      } else {
        setWarningMessage('');
      }
    }
  }

  async function onSubmit(ignoreWarning: boolean = true): Promise<boolean> {
    const errorMessages = getErrorMessages(tempFlightReport); //validate(ruleCode, "btnSave");

    setIsDataValid(!errorMessages || errorMessages.length === 0);
    if (errorMessages && errorMessages.length > 0) {
      setTempFlightReport({ ...tempFlightReport } as FlightReport);
      return false;
    }

    const token = auth.user?.access_token as string;
    setIsLoading(true);
    setWarningMessage('');
    if (tempUsLogs.some((x) => x.deleted)) {
      await onSaveLogs();
    }
    if (tempUSStandToStandDown && tempUSStandToStandDown.deleted) {
      await onSaveUsStandToStandDown();
      setUSStandToStandDown(undefined);
      setTempUSStandToStandDown(undefined);
      setUsLogs([]);
      setTempUsLogs([]);
    }
    if (tempFlyingHours?.some((x) => x.deleted)) {
      try {
        await FlyingHoursService.createUpdate(tempFlyingHours, tempFlightReport.flightReportId, token);
        const newFlyingHours = await getFlyingHours(
          tempFlightReport.flightReportId as number,
          token,
          fireNumberOptions,
          crewTypeOptions,
          costingActivityOptions,
          rateTypeOptions,
          rateUnitOptions,
          internalOrderOptions,
          costCenterOptions,
          fundOptions,
          accountOptions,
        );
        setFlyingHours(newFlyingHours);
        setTempFlyingHours(newFlyingHours);
      } catch (error) {
        console.log('Error', error);
        setError(error);
        setIsLoading(false);
        return false;
      }
    }

    if (tempFlightReport?.flightReportId > 0) {
      tempFlightReport.updateTimestamp = moment(new Date()).format('yyyy-MM-DD');

      tempFlightReport.updateUserId = auth?.user?.profile?.name ?? 'wildfire';
      try {
        const result = await FlightReportService.update(tempFlightReport, auth.user?.access_token as string);

        var vendorResult = {
          name: result.data?.vendorName,
          financeVendorId: result.data?.financeVendorId,
        };

        //Get corporate region
        var corporateRegion = getCorporateRegion(corporateRegionPaginationResult, result.data?.corporateRegionId ?? '');

        //Get contract registration
        if (result.data?.contractRegistrationId)
          var contractRegistrationObj = getContractRegistration(hiringContractsStateResult, result.data?.contractRegistrationId);

        //Get flying registration
        if (result.data?.flyingRegistrationId)
          var flyingRegistrationObj = getContractRegistration(hiringContractsStateResult, result.data?.flyingRegistrationId);

        const objFlightReport = new FlightReport({
          ...result.data,
          status: result.data?.status,
          corporateRegion: corporateRegion,
          vendor: vendorResult,
          contractRegistration: contractRegistrationObj,
          flyingRegistration: flyingRegistrationObj,
        });

        setTempFlightReport(objFlightReport);
        setFlightReport(objFlightReport);

        setCalloutVariant(CalloutVariant.success);
        setNotificationMessage('Flight Report summary saved!');

        setIsLoading(false);
        // })
      } catch (error) {
        setIsLoading(false);
        setError(error);
        return false;
      }
    } else {
      if (tempFlightReport) {
        tempFlightReport.createTimestamp = moment(new Date()).format('yyyy-MM-DD');

        tempFlightReport.createUserId = auth?.user?.profile?.name ?? 'wildfire';

        const flightReportDto = new FlightReport(tempFlightReport);
        flightReportDto.corporateRegion = getCorporateRegion(corporateRegionPaginationResult, tempFlightReport.corporateRegionId);
        flightReportDto.vendor = {
          name: tempFlightReport.vendorName,
          financeVendorId: tempFlightReport.financeVendorId,
        };
        flightReportDto.contractRegistration = getContractRegistration(hiringContractsStateResult, tempFlightReport.contractRegistrationId);
        try {
          const result = await FlightReportService.create(flightReportDto, auth.user?.access_token as string, ignoreWarning);
          if (result && result.data) {
            const objFlightReport = new FlightReport({
              ...tempFlightReport,
              flightReportId: result.data?.flightReportId,
              status: result.data?.status,
            });
            let contractType = result.data?.contractType;
            //start Create basing & basing non core expense for long term contract
            if (result.data?.hiringDetailsId) {
              // check if contract is long term
              contractType = flightReportDto.contractRegistration?.contractType;
              // i think use the flightReportDto.contractRegistration details? or have the api return it in the result?
            }
            if (contractType === ContractType.long) {
              const objExpenseRateTypeOptions = await ExpenseDetailCRUD.getRateTypes(result.data?.flightReportDate, '', 1000);
              let rateTypeOptions;
              if (objExpenseRateTypeOptions) {
                rateTypeOptions = bindRateTypeDropdown(objExpenseRateTypeOptions.data);
              }

              const objExpenseRateUnitsResponse = await ExpenseDetailCRUD.getRateUnits(result.data?.flightReportDate, '', 1000);
              let rateUnitOptions;
              if (objExpenseRateUnitsResponse) {
                rateUnitOptions = bindRateUnitDropdown(objExpenseRateUnitsResponse.data);
              }

              //Get contract rates
              const expenseContractRatesPaginationResult = await ExpenseDetailCRUD.getHiredVendorContractRates(
                objFlightReport,
                auth.user?.access_token as string,
              );

              if (rateTypeOptions && rateUnitOptions)
                await onFlightReportSaveCreateBasingExpenseLongTerm(
                  objFlightReport,
                  expenseContractRatesPaginationResult,
                  rateTypeOptions,
                  rateUnitOptions,
                  fireNumberOptions,
                  costingActivityOptions,
                  internalOrderOptions,
                  costCenterOptions,
                  fundOptions,
                  accountOptions,
                  auth,
                );
            }
            const fr = new FlightReport({ ...objFlightReport });
            setTempFlightReport(fr);
            setFlightReport(fr);
            await getExpenses(
              fr.flightReportId as number,
              fr.flightReportDate,
              fireNumberOptions,
              crewTypeOptions,
              costingActivityOptions,
              rateTypeOptions,
              rateUnitOptions,
              internalOrderOptions,
              costCenterOptions,
              fundOptions,
              accountOptions,
            );
            //send user notification
            setCalloutVariant(CalloutVariant.success);
            setNotificationMessage('Flight Report created!');
            navigate(`/flightReportDetail/${result.data?.flightReportId}`);

            setIsLoading(false);
          }
        } catch (error) {
          setError(error);
          setIsLoading(false);
          return false;
        }
      }
    }
    setIsLoading(false);
    return true;
  }

  //Drop down
  const [fireNumberOptions, setFireNumberOptions] = React.useState<IArrayOption[]>([]);
  const [costingActivityOptions, setCostingActivityOptions] = React.useState<IArrayOption[]>([]);
  const [rateTypeOptions, setRateTypeOptions] = React.useState<IArrayOption[]>([]);
  const [crewTypeOptions, setCrewTypeOptions] = React.useState<IArrayOption[]>([]);
  const [rateUnitOptions, setRateUnitOptions] = React.useState<IArrayOption[]>([]);

  //1GX coding financial
  const [internalOrderOptions, setInternalOrderOptions] = React.useState<IArrayOption[]>([]);
  const [costCenterOptions, setCostCenterOptions] = React.useState<IArrayOption[]>([]);
  const [fundOptions, setFundOptions] = React.useState<IArrayOption[]>([]);
  const [accountOptions, setAccountOptions] = React.useState<IArrayOption[]>([]);

  async function onSaveFlyingHours(): Promise<boolean> {
    setIsLoading(true);
    try {
      const response = await FlyingHoursService.createUpdate(tempFlyingHours, tempFlightReport?.flightReportId, auth.user?.access_token as string);
      if (tempFlightReport.status === FlightReportStatus.submitted) {
        onSubmittedStatusChange();
      } else {
        const flyingHoursResult = await getFlyingHours(
          tempFlightReport.flightReportId as number,
          auth.user?.access_token as string,
          fireNumberOptions,
          crewTypeOptions,
          costingActivityOptions,
          rateTypeOptions,
          rateUnitOptions,
          internalOrderOptions,
          costCenterOptions,
          fundOptions,
          accountOptions,
        );
        setFlyingHours(flyingHoursResult);
        setTempFlyingHours(flyingHoursResult);
      }

      setCalloutVariant(CalloutVariant.success);
      setNotificationMessage('Flying hours summary saved!');

      setWarning(response.responseDtos);
      setIsLoading(false);
      return true;
    } catch (error) {
      console.log('Error', error);
      setError(error);
    }
    setIsLoading(false);
    return false;
  }
  async function onSaveExpenses(): Promise<boolean> {
    if (expensesData) {
      setIsLoading(true);
      try {
        const response = await ExpenseService.createUpdate(tempExpensesData, tempFlightReport?.flightReportId, auth.user?.access_token as string);
        if (response.status === 401) {
          // Redirect to the login page using React Router
          navigate('/');
        }
        setCalloutVariant(CalloutVariant.success);
        try {
          //Change status from submitted to inprogress
          if (tempFlightReport.status === FlightReportStatus.submitted) {
            onSubmittedStatusChange();
          } else {
            await getExpenses(
              tempFlightReport.flightReportId,
              tempFlightReport.flightReportDate,
              fireNumberOptions,
              crewTypeOptions,
              costingActivityOptions,
              rateTypeOptions,
              rateUnitOptions,
              internalOrderOptions,
              costCenterOptions,
              fundOptions,
              accountOptions,
            );
          }

          // Code inside this block will only run after getExpenses is completed
          setCalloutVariant(CalloutVariant.success);
          setNotificationMessage('Flight expenses saved!');

          setIsLoading(false);
          return true;
        } catch (error) {
          // Handle errors from getExpenses if needed
          console.error('Error in getExpenses:', error);
        }
      } catch (error) {
        setError(error);
      }
      setIsLoading(false);
      return false;
    }
    return false;
  }

  async function onSaveLogs(): Promise<boolean> {
    if (tempUsLogs.length > 0 && flightReport?.flightReportId) {
      setIsLoading(true);

      var validUSLogs = tempUsLogs.filter((x) => x.startTime !== '' && x.endTime !== '' && x.reason !== '');

      try {
        await UnserviceableLogService.createUpdate(validUSLogs, flightReport?.flightReportId, auth.user?.access_token as string);

        await getUSLog(flightReport.flightReportId);

        //Change status from submitted to inprogress
        if (flightReport.status === FlightReportStatus.submitted) {
          onSubmittedStatusChange();
        }

        setCalloutVariant(CalloutVariant.success);
        setNotificationMessage('Unserviceable log saved!');

        setIsLoading(false);
        return true;
      } catch (error) {
        setError(error);
      }
    }
    setIsLoading(false);
    return false;
  }

  async function getUnserviceableStandToStandDownTime(flightReportId: string, flightReportDate: string) {
    const response = await StandToStandDownTimeService.getById(flightReportId, auth.user?.access_token as string);

    if (response.status === 'true' && response.data) {
      //Set Unserviceable StandTo StandDown
      var strStandToSubstr = removeStringCharacters(response.data.standTo, 3);
      var strStandDownSubstr = removeStringCharacters(response.data.standDown, 3);

      setUSStandToStandDown(
        new USStandToStandDown({
          ...response.data,
          standTo: strStandToSubstr,
          standDown: strStandDownSubstr,
        }),
      );
      setTempUSStandToStandDown(
        new USStandToStandDown({
          ...response.data,
          standTo: strStandToSubstr,
          standDown: strStandDownSubstr,
        }),
      );
    } else {
      setTempUSStandToStandDown(
        new USStandToStandDown({
          flightReportId: flightReportId,
          unserviceableDate: flightReportDate,
        }),
      );
      setUSStandToStandDown(
        new USStandToStandDown({
          flightReportId: flightReportId,
          unserviceableDate: flightReportDate,
        }),
      );
    }
  }

  async function onSaveUsStandToStandDown(): Promise<boolean> {
    setIsLoading(true);
    if (tempUSStandToStandDown) {
      if (tempUSStandToStandDown?.uSStandToStandDownId) {
        try {
          tempUSStandToStandDown.updateTimestamp = moment(new Date()).format('yyyy-MM-DD');
          tempUSStandToStandDown.updateUserId = auth?.user?.profile?.name ?? 'wildfire';

          const response = await StandToStandDownTimeService.update(tempUSStandToStandDown as USStandToStandDown, auth.user?.access_token as string);

          if (response.status && response.data) {
            //Set Unserviceable StandTo StandDown
            var strStandToSubstr = removeStringCharacters(response.data.standTo, 3);
            var strStandDownSubstr = removeStringCharacters(response.data.standDown, 3);

            setUSStandToStandDown(
              new USStandToStandDown({
                ...response.data,
                standTo: strStandToSubstr,
                standDown: strStandDownSubstr,
              }),
            );

            setTempUSStandToStandDown(
              new USStandToStandDown({
                ...response.data,
                standTo: strStandToSubstr,
                standDown: strStandDownSubstr,
              }),
            );

            //Change status from submitted to inprogress
            if (tempFlightReport.status === FlightReportStatus.submitted) {
              onSubmittedStatusChange();
            }

            setCalloutVariant(CalloutVariant.success);
            setNotificationMessage('Stand To / Stand Down time saved!');

            setIsLoading(false);
            return true;
          }
        } catch (error) {
          setError(error);
        }
      } else {
        tempUSStandToStandDown.createTimestamp = moment(new Date()).format('yyyy-MM-DD');
        tempUSStandToStandDown.createUserId = auth?.user?.profile?.name ?? 'wildfire';
        try {
          const response = await StandToStandDownTimeService.create(tempUSStandToStandDown, auth.user?.access_token as string);

          if (response.status && response.data) {
            var createdUnserviceableStandToStandDown = new USStandToStandDown({
              ...uSStandToStandDown,
              flightReportId: response.data.flightReportId,
            });

            setUSStandToStandDown(
              new USStandToStandDown({
                ...createdUnserviceableStandToStandDown,
              }),
            );
            setTempUSStandToStandDown(
              new USStandToStandDown({
                ...createdUnserviceableStandToStandDown,
              }),
            );

            await getUnserviceableStandToStandDownTime(tempFlightReport.flightReportId as string, tempFlightReport.flightReportDate);

            //Change status from submitted to inprogress
            if (tempFlightReport.status === FlightReportStatus.submitted) {
              onSubmittedStatusChange();
            }

            //send user notification
            setCalloutVariant(CalloutVariant.success);
            setNotificationMessage('Stand To / Stand Down time created!');

            setIsLoading(false);
            return true;
          }
        } catch (error) {
          setError(error);
          setIsLoading(false);
        }
      }
    }
    return false;
  }

  const errorsExist = (): boolean => {
    const flightReportErrors = getErrorMessages(flightReport);
    const flyingHoursErrors = flyingHours.flatMap((fh) => getFlyingHoursErrorMessages(fh));
    const expensesErrors = expensesData?.expenseDetails.flatMap((ed) => getExpenseDetailErrorMessages(ed)) ?? [];
    const otherErrors = getFlightOtherExpensesErrorMessages(expensesData?.flightOtherExpenses);
    const usLogsErrors = usLogs.flatMap((log) => getUSLogErrorMessages(log));
    const usStandToStandDownErrors = [];

    return flightReportErrors.length > 0 ||
      flyingHoursErrors.length > 0 ||
      expensesErrors.length > 0 ||
      otherErrors.length > 0 ||
      usLogsErrors.length > 0 ||
      usStandToStandDownErrors.length > 0
      ? true
      : false;
  };
  return (
    <Suspense fallback={<GoACircularProgress visible={true} />}>
      <GoACircularProgress variant='fullscreen' size='small' visible={isLoading || !isLoaded} />

      {isLoaded && (
        <div className={container}>
          <SideBar
            isNew={id === 'new'}
            ruleCode={ruleCode}
            flightReport={tempFlightReport}
            onChange={(updatedFields: Partial<FlightReport>) => {
              const updatedFlightReport = {
                ...tempFlightReport,
                ...updatedFields,
              } as FlightReport;
              setFlightReportErrors(updatedFlightReport);
              const errors = getErrorMessages(updatedFlightReport);
              setIsDataValid(errors.length === 0);
              setTempFlightReport(updatedFlightReport);
            }}
            onSave={(ignoreWarning) => {
              return onSubmit(ignoreWarning);
            }}
            onCancel={() => {
              const newFlightReport = tempFlightReport as IFlightReport;
              if (JSON.stringify(newFlightReport) !== JSON.stringify(flightReport)) {
                setShowUnsavedChangesModal('flightreport');
              }
            }}
            onNoFlyDay={(value: boolean) => {
              if (value) {
                // set flight report noflyday if modal says yes
                setShowNoFlyDayModal(true);
              } else {
                const updatedFlightReport = {
                  ...tempFlightReport,
                  noFlyDay: false,
                } as FlightReport;
                setTempFlightReport(updatedFlightReport);
              }
            }}
            isChildDataValid={isDataValid}
            corporateRegionPaginationResult={corporateRegionPaginationResult}
            onChangeUnservicableReport={(value: boolean) => {
              const updatedFlightReport = {
                ...tempFlightReport,
                unserviceableReport: value,
              } as FlightReport;
              if (!value) {
                setShowUnserviceableReportModal(true);
              }
              setTempFlightReport(updatedFlightReport);
            }}
          />
          <MainPanel
            flightReport={tempFlightReport}
            ruleCode={ruleCode}
            isChildDataValid={isDataValid}
            flyingHoursChanged={JSON.stringify(tempFlyingHours) !== JSON.stringify(flyingHours)}
            expensesChanged={JSON.stringify(tempExpensesData) !== JSON.stringify(expensesData)}
            usLogsChanged={JSON.stringify(tempUsLogs) !== JSON.stringify(usLogs)}
            usStandToStandDownChanged={JSON.stringify(tempUSStandToStandDown) !== JSON.stringify(uSStandToStandDown)}
            onError={(errorMessages: string[]) => {
              setIsDataValid(errorMessages.length === 0);
            }}
            setWarning={setWarning}
            setError={setError}
            setIsLoading={setIsLoading}
            domainData={domainData}
            onSaveFlyingHours={onSaveFlyingHours}
            onCancelFlyingHours={() => {
              if (JSON.stringify(tempFlyingHours) !== JSON.stringify(flyingHours)) {
                setShowUnsavedChangesModal('flyinghours');
              }
            }}
            onChangeFlyingHours={setTempFlyingHours}
            flyingHours={tempFlyingHours}
            expenses={tempExpensesData}
            onChangeExpenses={(newValue: FlightExpenses) => {
              setTempExpensesData(newValue);
            }}
            onCancelExpenses={() => {
              if (JSON.stringify(tempExpensesData) !== JSON.stringify(expensesData)) {
                setShowUnsavedChangesModal('expenses');
              }
            }}
            onSaveExpenses={onSaveExpenses}
            notes={notes}
            onNotesChange={onNotesChange}
            uslogs={tempUsLogs}
            onChangeUSLogs={(newValue: IUSLog[]) => {
              setTempUsLogs(newValue);
            }}
            onCancelUSLogs={() => {
              if (JSON.stringify(tempUsLogs) !== JSON.stringify(usLogs)) {
                setShowUnsavedChangesModal('logs');
              }
            }}
            onSaveUSLogs={onSaveLogs}
            uSStandToStandDown={tempUSStandToStandDown}
            onUsStandToStandDownSave={onSaveUsStandToStandDown}
            onUsStandToStandDownCancel={() => {
              if (JSON.stringify(tempUSStandToStandDown as IUSStandToStandDown) !== JSON.stringify(uSStandToStandDown as IUSStandToStandDown)) {
                setShowUnsavedChangesModal('standtostanddown');
              }
            }}
            onUsStandToStandDownChange={(newValue: USStandToStandDown) => {
              setUsStandToStandDownErrors(newValue);
              setTempUSStandToStandDown(newValue);
            }}
            showUnserviceableReportTab={flightReport.unserviceableReport}
          />
        </div>
      )}

      <GoAModal
        heading='No Fly Day Selected'
        open={showNoFlyDayModal}
        actions={
          <GoAButtonGroup alignment='end'>
            <GoAButton type='secondary' onClick={() => setShowNoFlyDayModal(false)}>
              No, cancel
            </GoAButton>
            <GoAButton onClick={() => onNoFlyDayConfirmChanges()}>Yes, confirm</GoAButton>
          </GoAButtonGroup>
        }
      >
        <div className='divUlLi'>
          <p>The following values will be removed:</p>

          <ul className='b'>
            <li>
              Flying Hours ({tempFlyingHours?.length ?? 0}
              lines)
            </li>
            <li>Meter Start, Finish and Difference </li>
            <li>Departure Location</li>
          </ul>
        </div>
      </GoAModal>
      <GoAModal
        heading={"Unserviceable report selected 'No'"}
        open={showUnserviceableReportModal}
        actions={
          <GoAButtonGroup alignment='end'>
            <GoAButton onClick={() => onUnserviceableReportCancel()}>No, cancel</GoAButton>
            <GoAButton onClick={() => onUnserviceableReportConfirm()}>Yes, confirm</GoAButton>
          </GoAButtonGroup>
        }
      >
        <p>The unserviceable report tab, along with its data, will be removed.</p>
      </GoAModal>
      <GoAModal
        heading='Warning'
        open={!!warningMessage}
        onClose={() => setWarningMessage('')}
        actions={
          <GoAButtonGroup alignment='end'>
            <GoAButton onClick={() => setWarningMessage('')}>No, discard changes</GoAButton>
            <GoAButton onClick={() => onSubmit(true)}>Yes, continue</GoAButton>
          </GoAButtonGroup>
        }
      >
        <div
          dangerouslySetInnerHTML={{
            __html: warningMessage,
          }}
        />
      </GoAModal>
      <GoAModal
        heading={modalHeading}
        calloutVariant={calloutVariant}
        open={notificationMessage !== ''}
        actions={
          <GoAButtonGroup alignment='end'>
            <GoAButton
              onClick={() => {
                setNotificationMessage('');
              }}
            >
              Okay
            </GoAButton>
          </GoAButtonGroup>
        }
      >
        <div dangerouslySetInnerHTML={{ __html: notificationMessage }} />
      </GoAModal>
      <GoAModal
        heading='You have unsaved changes'
        open={showUnsavedChangesModal !== 'none'}
        actions={
          <GoAButtonGroup alignment='end'>
            <GoAButton onClick={() => setShowUnsavedChangesModal('none')}>Cancel</GoAButton>
            <GoAButton
              onClick={() => {
                if (showUnsavedChangesModal === 'flightreport') {
                  setTempFlightReport(new FlightReport({ ...flightReport }));
                  if (!flightReport.noFlyDay && tempFlightReport.noFlyDay) {
                    setTempFlyingHours(flyingHours);
                  }
                } else if (showUnsavedChangesModal === 'flyinghours') {
                  setTempFlyingHours(flyingHours);
                } else if (showUnsavedChangesModal === 'expenses') {
                  setTempExpensesData(expensesData);
                } else if (showUnsavedChangesModal === 'standtostanddown') {
                  setTempUSStandToStandDown(uSStandToStandDown);
                } else if (showUnsavedChangesModal === 'logs') {
                  setTempUsLogs(usLogs);
                } else if (showUnsavedChangesModal === 'notes') {
                  // setTempNotes(notes);
                }

                setIsDataValid(!errorsExist());
                setShowUnsavedChangesModal('none');
              }}
            >
              Discard changes
            </GoAButton>
          </GoAButtonGroup>
        }
      >
        <p>Are you sure you want to discard changes?</p>
      </GoAModal>
    </Suspense>
  );
};

export default FlightReportDetail;
